
































import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import { Produto, ItemDaVenda, ProdutoFilho } from '../../models'
import {
	converterProdutoParaProdutoSimples,
	obterQuantidadePesadaNaBalanca,
} from '@/shareds/produto-shareds'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindConfiguracaoDaContaUseCase, FindProdutoUseCase } from '@/usecases'
import { ConfiguracaoDaConta } from '@/models/ConfiguracaoDaConta'
import DialogoDeAutenticacao from '@/views/application/venda/DialogoDeAutenticacao.vue'
import { getRequestError } from '@/helpers/axios-helpers'
import Confirmacao from '../ui/Confirmacao.vue'

@Component({
	components: {
		BuscaDeProduto,
		DialogoDeAutenticacao,
		Confirmacao,
	},
})
export default class CampoDeItemDeVenda extends Vue {
	@Ref() campo!: BuscaDeProduto
	@Ref() dialogoDeAutenticacao!: DialogoDeAutenticacao
	@Ref('confirmarEstoqueNegativo') confirmarEstoqueNegativo!: Confirmacao
	@Prop({ type: Boolean, default: true }) validarProduto!: boolean
	@Prop({ type: Boolean, default: false }) isTelaDeTroca!: boolean
	@Prop({ type: String, default: 'Venda' }) tipoMovimentacao!: string
	@Prop({ type: Boolean, default: false }) validarEmissaoDeNota!: boolean

	busca: string | null = null
	produto: Produto | null = null
	erro: null | Error | unknown = null
	configuracaoDeConta: ConfiguracaoDaConta | null = null

	quantidade = 1

	VendaModule = VendaModule
	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	async created() {
		try {
			this.configuracaoDeConta =
				await this.findConfiguracaoDaContaUseCase.find()
		} catch (error: any) {
			this.erro = error
		}
	}

	async enviarItemDeVenda(produto: ProdutoFilho | null) {
		if (!produto) return

		const item: ItemDaVenda = this.criarItemDaVenda(produto, 0)

		try {
			this.$emit('input', item)
			this.resetarQuantidadeEProduto()
			UserLoginStore.setAutenticandoParaLiberarVendaSemEstoque(true)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async enviarItemDeVendaValidado(produto: ProdutoFilho | null) {
		if (!produto) return
		const quantidadeDeItens =
				produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT'
					? this.quantidade
					: obterQuantidadePesadaNaBalanca(
						this.busca || '',
						this.configuracaoDeConta?.medida || 6,
						this.configuracaoDeConta?.eans || 7,
						this.configuracaoDeConta?.casasNumericas || 4,
					)
		
		const item: ItemDaVenda = this.criarItemDaVenda(produto, quantidadeDeItens)

		try {
			if (this.validarEmissaoDeNota) {
				await this.validarEstoqueEmissaoDeNota(produto)
			} else {
				await this.validarEstoque(produto)
			}

			this.$emit('input', item)
			this.resetarQuantidadeEProduto()

			const podeLiberarEstoque = UserLoginStore.permiteRegraDeNegocio('pode-liberar-produto-sem-estoque')
			if(podeLiberarEstoque){
				item.autenticadoParaLiberarProdutoSemEstoque = true
			}
			
		} catch (error: any) {
			if (getRequestError(error) == 'A quantidade do produto excede o estoque disponível' ||
				getRequestError(error) == `Produtos ${produto.sku} sem quantidade disponível em estoque` ||
				getRequestError(error) == 'Produto não possui estoque parametrizado') {

				if (this.validarEmissaoDeNota) {
					if (!await VendaModule.chamarConfirmacaoEstoqueNegativo()) {
						this.resetarQuantidadeEProduto()
						AlertModule.setError(error)
						return
					}
				}

				if (this.perguntarSeDesejaNegativarEstoque) {
					if (!await VendaModule.chamarConfirmacaoEstoqueNegativo()) {
						this.resetarQuantidadeEProduto()
						return
					}
				}

				AlertModule.setError(error)
		
				const resultado = await VendaModule.autenticarAcaoTelaDeCaixa({ 
					regra: 'pode-liberar-produto-sem-estoque',
				})
				this.resetarQuantidadeEProduto()
				if (resultado && resultado.autenticado) {
					item.autenticadoParaLiberarProdutoSemEstoque = true
					item.usuarioIdLiberacaoVendaSemEstoque = resultado.usuarioId
					this.$emit('input', item)
				} 
			} else if(getRequestError(error) !== 'A quantidade do produto excede o estoque disponível' ||
					getRequestError(error) !== `Produtos ${produto.sku} sem quantidade disponível em estoque`) {
				AlertModule.setError(error)
				this.resetarQuantidadeEProduto()
			} else {
				AlertModule.setError(error)
			}
		}
	}

	validarEstoque(produto: ProdutoFilho | null) {
		if (!produto) return
		const quantidadeDoItem = (VendaModule.vendaAtual?.itens
			.find(item => item.produto.id === produto.id)?.quantidade || 0) +
			this.quantidade
		const podeGerarEstoque = this.$route.fullPath === '/caixa' ?
			VendaModule.lojaDaVenda?.configuracaoDaLoja.podeGerarEstoqueNaVenda :
			VendaModule.lojaDaEntrada?.configuracaoDaLoja.podeGerarEstoqueNaVenda

		const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta
			&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado)
			&& VendaModule.vendaAtual.itens.some(item => item.produto.id === produto.id)

		if (!podeGerarEstoque || this.perguntarSeDesejaNegativarEstoque) {
			if ((!this.podeLiberarProdutoSemEstoque || this.perguntarSeDesejaNegativarEstoque)
			&& !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca) {
				if (VendaModule.lojaDaVenda) {
					const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta 
						&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado) 
						&& VendaModule.vendaAtual.itens.some(item => item.produto.id === produto.id) 

					if(((!podeGerarEstoque || this.perguntarSeDesejaNegativarEstoque) && this.tipoMovimentacao !== 'Entrada' && this.tipoMovimentacao !== 'Balanco') && !this.$route.path.includes('/estoques')) {	
						if((!this.podeLiberarProdutoSemEstoque || this.perguntarSeDesejaNegativarEstoque) && !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca) {
							if(VendaModule.lojaDaVenda) {
								return this.findProdutoUseCase.validarProduto(produto.sku || '', VendaModule.lojaDaVenda.id, quantidadeDoItem, this.perguntarSeDesejaNegativarEstoque)
							} else if (VendaModule.lojaDaEntrada) {
								return this.findProdutoUseCase.validarProduto(produto.sku || '', VendaModule.lojaDaEntrada.id, quantidadeDoItem)
							}
						}
					}}
			}}
	}

	validarEstoqueEmissaoDeNota(produto: ProdutoFilho | null) {
		if (!produto) return
		const quantidadeDoItem = (VendaModule.emissaoEntradaAtual?.itens
			.find(item => item.produto.id === produto.id)?.quantidade || 0) +
			this.quantidade
		const podeGerarEstoque = VendaModule.lojaDaEntrada?.configuracaoDaLoja.podeGerarEstoqueNaVenda

		if (!podeGerarEstoque && VendaModule.lojaDaEntrada) {
			if(!podeGerarEstoque && this.tipoMovimentacao !== 'Entrada' && this.tipoMovimentacao !== 'Balanco') {	
				return this.findProdutoUseCase.validarProduto(produto.sku || '', VendaModule.lojaDaEntrada.id, quantidadeDoItem)
			}
		}
	}

	criarItemDaVenda(produto: ProdutoFilho, quantidadeDeItens: number): ItemDaVenda {
		return {
			id: '',
			produto: converterProdutoParaProdutoSimples(produto),
			quantidade: quantidadeDeItens,
			quantidadeLida: 0,
			desconto: { isPercentual: true, valor: 0.0 },
			preco: produto.preco || 0,
			precoDeCusto: 0,
			idConjunto: null,
			descontoVarejo: 0,
			percentualCashback: 0,
			diasParaEfetivarCashback: 0,
			isBrinde: false,
			idItemNotaOrigem: null,
			chaveNotaOrigem: null,
			diasParaExpirarCashback: 0,
			possuiDescontoPorTabela: false,
			valorDescontoRateadoDoItem: 0,
			itemDeDevolucao: false,
			isTotalmenteTrocado: false,
			motivoCancelamento: null,
			isCompra: false,
			idItemOrigem: '',
			isDaVendaReaberta: false,
			vendedor: null,
			autenticadoParaLiberarProdutoSemEstoque: false,
			vendaOrigemDoItem: null,
			valorFreteRateado: 0,
			isItemReferenteATroca: false,
			isDeOutraLoja: false,
			percentualDescontoTabelaPreco: 0,
			precoDeCustoReal: 0,
		}
	}

	resetarQuantidadeEProduto() {
		this.quantidade = 1;
		setTimeout(() => {
			this.produto = null;
		});
	}

	focus() {
		this.campo.focus()
	}

	blur() {
		this.campo.blur()
	}

	@Watch('busca')
	onChangeBusca(busca: string) {
		if (!this.podeAlterarQuantidadeProduto) return
		if (!busca || !busca.match(/\*|x/g)) return
		const quantidade = Number(busca.split(/\*|x/)[0])
		this.quantidade =
			Number.isNaN(quantidade) || quantidade <= 0 ? 1 : quantidade
		setTimeout(() => {
			this.busca = null
		})
	}

	get podeAlterarQuantidadeProduto() {
		return UserLoginStore.permiteRegraDeNegocio(
			'informar-quantidade-de-produtos',
		)
	}

	get podeLiberarProdutoSemEstoque() {
		return UserLoginStore.permiteRegraDeNegocio('pode-liberar-produto-sem-estoque')
	}

	get perguntarSeDesejaNegativarEstoque() {
		return this.$route.fullPath === '/caixa' && VendaModule.lojaDaVenda?.configuracaoDaLoja.permiteConfiguracaoDeNotificacoes
	}
}
